import type { AssetId, OutlookSpaceAssetId } from 'owa-timestream-types';
import localAssetIdMap from './localAssetIdMap';

export default function getLocalAssetId(serverId: OutlookSpaceAssetId): AssetId | undefined {
    return localAssetIdMap.get(serverId);
}
